import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { useAuthStore } from "../store/AuthStore"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export function getToken() {
  try {
    return useAuthStore.getState().accessToken;
  } catch (err) {
    console.error("Failed to read token:", err);
    return null;
  }
}